function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import "./index.less";
import { isEmpty } from '@fe-util/common';
import { Icon } from "../../..";
import { getLink } from "../../utils";
import Accordion from "../Accordion";
import TextPanel from "../TextPanel";
var Mobile = function Mobile(_ref) {
  var _ref$menus = _ref.menus,
    menus = _ref$menus === void 0 ? [] : _ref$menus,
    visible = _ref.visible,
    superCareInfo = _ref.superCareInfo,
    originUrl = _ref.originUrl,
    superAgentText = _ref.superAgentText,
    langText = _ref.langText,
    tabs = _ref.tabs,
    onSuperAgent = _ref.onSuperAgent,
    onChangeLang = _ref.onChangeLang;
  var _useState = useState(visible),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  useEffect(function () {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    setShow(visible);
  }, [visible]);
  var processArray = function processArray() {
    var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var resultArray = [];
    var arrayA = [];
    var arrayB = [];
    for (var i = 0; i < children.length; i++) {
      var item = children[i];
      if ((i + 1) % 2 === 0) {
        arrayB.push(item);
      } else {
        arrayA.push(item);
      }
    }
    resultArray = [].concat(arrayA, arrayB);
    return resultArray;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-wrapper",
    "data-visible": show
  }, !isEmpty(tabs) && /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-tab"
  }, tabs && tabs.map(function (item) {
    return /*#__PURE__*/React.createElement("a", {
      href: getLink(item === null || item === void 0 ? void 0 : item.href, originUrl),
      className: "tab-item ".concat(item.active ? 'active' : ''),
      key: item === null || item === void 0 ? void 0 : item.value,
      id: "mobile-header-tab".concat(item === null || item === void 0 ? void 0 : item.value),
      target: item === null || item === void 0 ? void 0 : item.target
    }, item === null || item === void 0 ? void 0 : item.label);
  })), /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-scroll"
  }, menus.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: (item === null || item === void 0 ? void 0 : item.value) || index
    }, /*#__PURE__*/React.createElement(Accordion, {
      header: {
        label: item === null || item === void 0 ? void 0 : item.label,
        icon: item === null || item === void 0 ? void 0 : item.icon,
        href: getLink(item === null || item === void 0 ? void 0 : item.href, originUrl),
        target: item === null || item === void 0 ? void 0 : item.target
      },
      className: 'menu',
      lock: !(item !== null && item !== void 0 && item.children && (item === null || item === void 0 ? void 0 : item.children.length) > 0)
    }, /*#__PURE__*/React.createElement("div", {
      className: "menu-content"
    }, item && item.children && item.children.map(function (subItem) {
      return /*#__PURE__*/React.createElement(Accordion, {
        key: subItem === null || subItem === void 0 ? void 0 : subItem.value,
        header: {
          label: subItem === null || subItem === void 0 ? void 0 : subItem.label,
          icon: subItem === null || subItem === void 0 ? void 0 : subItem.icon,
          href: getLink(subItem === null || subItem === void 0 ? void 0 : subItem.href, originUrl),
          target: subItem === null || subItem === void 0 ? void 0 : subItem.target
        },
        lock: subItem === null || subItem === void 0 ? void 0 : subItem.lock,
        className: "mobile-sub-menu-accordion"
      }, /*#__PURE__*/React.createElement(TextPanel, {
        subMenus: processArray(subItem === null || subItem === void 0 ? void 0 : subItem.children),
        originUrl: originUrl
      }));
    }))), ((item === null || item === void 0 ? void 0 : item.label) === 'Claims' || (item === null || item === void 0 ? void 0 : item.label) === '索償') && superCareInfo && (superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.label) && /*#__PURE__*/React.createElement("div", {
      className: "iron-SuperCase-box",
      style: {
        backgroundImage: "url(".concat(superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.backgroundImage, ")")
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.href,
      target: superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.target
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: superCareInfo === null || superCareInfo === void 0 ? void 0 : superCareInfo.label
      }
    }))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-footer"
  }, superAgentText && /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-footer-item",
    onClick: onSuperAgent
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "agent"
  }), /*#__PURE__*/React.createElement("span", null, superAgentText)), langText && /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-footer-item",
    onClick: onChangeLang
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "earth"
  }), /*#__PURE__*/React.createElement("span", null, langText))))));
};
export default Mobile;